import { render, staticRenderFns } from "./candylist.vue?vue&type=template&id=4f0b6c75&scoped=true"
import script from "./candylist.vue?vue&type=script&lang=js"
export * from "./candylist.vue?vue&type=script&lang=js"
import style0 from "./candylist.vue?vue&type=style&index=0&id=4f0b6c75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0b6c75",
  null
  
)

export default component.exports